import { useI18n } from '../../i18n/I18nContext';

function TextBlock({title, text}) {
    const { t } = useI18n();

    return (
        <div data-reveal className="flex flex-col flex-1">
          <h3 className="text-base font-bold text-dark uppercase">{title}{t("common.colon")}</h3>
          <br />
          <div className="text-base text-dark" dangerouslySetInnerHTML={{__html: text}}></div>
        </div>
    );
}

function Details({info, focus, lastSection}) {
    const { t } = useI18n();

    return (
        <section id="details" className={"relative overflow-x-clip px-10" + (lastSection ? " pb-[5rem]" : "")}>
          <div className="relative max-w-[1200px] mx-auto">
            <div className="flex flex-col items-center gap-x-12 lg:items-start lg:flex-row">
              { info && <TextBlock title={t("projects.common.detailedDescription")} text={info} /> }
              { focus && [
                info && <br className="lg:hidden" />,
                <TextBlock title={t("projects.common.role")} text={focus} />
              ]}
            </div>
          </div>
        </section>
    );
}

export default Details;
